'use client';

import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';

import { cn } from '@/lib/utils';

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> & {
  /** Render as a different element/tag (e.g. "h1", "h2") while keeping label styles. */
  as?: React.ElementType;
};

function Label({ className, as: Component, ...props }: LabelProps) {
  const classes = cn(
    'flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
    className,
  );

  if (Component) {
    return <Component data-slot='label' className={classes} {...props} />;
  }

  return (
    <LabelPrimitive.Root data-slot='label' className={classes} {...props} />
  );
}

export { Label };
